export const TpSlTriggerTimeIndicatorMapper = {
  Long: {
    tp: '+',
    sl: '-',
  },
  Short: {
    tp: '-',
    sl: '+',
  },
} as const;

// 가격이 낮아지면 액션을 할지 높아지면 할지 전달하는 부분
export const TpSlTriggerDirectionMapper = {
  Long: {
    tp: 'Up',
    sl: 'Down',
  },
  Short: {
    tp: 'Down',
    sl: 'Up',
  },
} as const;

const PriceSet = ['-1', '-0.1', '+0.1', '+1'];

export const TpSlPriceButtonSet = {
  Long: {
    tp: PriceSet,
    sl: PriceSet,
  },
  Short: {
    tp: PriceSet,
    sl: PriceSet,
  },
};
